import {
  all, takeEvery, select, put
} from 'redux-saga/effects';
import { formTypes as FormTypes } from 'config/formTypes';
import { getSectionFromFormType, getSubsectionFromFormType } from 'helpers/form';
import * as ActionTypes from './actionTypes';
import { updateSectionSuccess, updateSectionFailure } from './actions';
import { UpdateSectionAction } from './actions';
import { SectionConfig, SubsectionConfig } from './reducer';
import { rootSelectors } from '../selectors';

export function* onSectionUpdate(action: UpdateSectionAction) {
  const { sectionName, subsectionName } = action.payload;

  try {
    const formType = yield select(rootSelectors.application.getFormType);

    let sectionConfig: SectionConfig = {
      path: sectionName,
      name: sectionName,
      ...getSectionFromFormType(formType, { name: sectionName }),
    };
    let subsectionConfig: SubsectionConfig = {
      path: subsectionName,
      name: subsectionName,
      key: '',
      label: '',
    };

    if (sectionName === 'package') {
      sectionConfig = FormTypes.reviewSections;
      subsectionConfig = FormTypes.reviewSections.subsections.find(
        (e) => e.path === subsectionName
      ) as SubsectionConfig;
    } else if (subsectionName !== 'review' || sectionName !== 'locked') {
      subsectionConfig = getSubsectionFromFormType(formType, sectionName, subsectionName);
    }

    if (sectionConfig !== undefined) {
      yield put(updateSectionSuccess(sectionConfig, subsectionConfig));
    } else {
      throw new Error('SectionConfig is undefined.');
    }
  } catch (err) {
    yield put(updateSectionFailure(sectionName, subsectionName));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(ActionTypes.UPDATE_SECTION, onSectionUpdate)]);
}
